import { Box, Button, FormControl, Typography } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppButton from "../../components/app-button/AppButton";
import AppDialog from "../../components/app-dialog/AppDialog";
import Iconify from "../../components/iconify/Iconify";
import TableSelectionAutocompleteInput from "../../components/table-change-dialog/TableSelectionAutocompleteInput";
import {
  ORDER_TYPE_CODES,
  getOrderTypeChangeScenario,
  getOrderTypeLabel,
} from "../../constants/enums";
import {
  clearSelectedTable,
  setOrderType,
  updateOrderType,
} from "../../reduxStore/slices/cartSlice";
import { useNotify } from "../../utils/snackbarUtils";

function OrderTypeChangeConfirmationDialog({
  open,
  onDialogCancel,
  orderType,
  currentOrderType,
  selectedTable,
  onConfirm,
}) {
  const dispatch = useDispatch();
  const { showSuccess, handleApiError, showError } = useNotify();

  const { user } = useSelector((state) => state.auth);
  const { tablesWithStatus, activeOrderId, orderId } = useSelector(
    (state) => state.cart
  );

  const storeId = user?.storeId;

  const [newTable, setNewTable] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const tableName = selectedTable?.table?.table_name || "";
  const dineArea = selectedTable?.dine_area_name;
  const displayName = dineArea ? `${tableName} (${dineArea})` : tableName;
  const orderTypeLabel = getOrderTypeLabel(currentOrderType?.type);
  const modalDialogTitle = `Convert to ${orderTypeLabel}`;

  const scenario = getOrderTypeChangeScenario(currentOrderType, orderType, {
    tableName: displayName,
  });

  const handleTableChange = (_, value) => {
    setNewTable(value);
  };

  const handleConfirm = async () => {
    if (scenario.requireTableSelection) {
      if (!newTable?.dine_area_table_id) {
        showError("Please select a new table.");
        return;
      }
    }
    try {
      setIsLoading(true);
      const obj = {
        store_id: storeId,
        order_id: orderId,
        order_uid: activeOrderId,
        order_type_id: currentOrderType.type,
        dine_area_table_uid: newTable.dine_area_table_uid,
        order_dine_table_id: selectedTable?.table?.order_dine_table_id || "",
        order_dine_table_uid: selectedTable?.table?.order_dine_table_uid || "",
      };
      await dispatch(updateOrderType(obj)).unwrap();
      if (currentOrderType.type !== ORDER_TYPE_CODES.DINE_IN) {
        dispatch(clearSelectedTable());
      }
      // update redux state tables
      dispatch(setOrderType({ type: currentOrderType.type }));
      onDialogCancel();
      setIsLoading(false);
      showSuccess(`Order converted to ${orderTypeLabel} successfully.`);
    } catch (err) {
      setIsLoading(false);
      handleApiError(err);
    }
  };

  const dialogFooter = (
    <Box sx={{ display: "flex", gap: 2 }}>
      <Button size="medium" onClick={onDialogCancel}>
        Cancel
      </Button>
      <AppButton
        isLoading={isLoading}
        fullWidth
        size="medium"
        variant="contained"
        onClick={handleConfirm}
      >
        Assign & Convert
      </AppButton>
    </Box>
  );

  return (
    <>
      <AppDialog
        maxWidth="xs"
        isOpen={open}
        id={"change_order_type_dialog"}
        title={<>{modalDialogTitle}</>}
        footer={dialogFooter}
      >
        <Box
          style={{
            margin: "20px 5px",
          }}
        >
          <Box
            sx={{
              my: 1,
              p: 1.5,
              borderRadius: 1,
              backgroundColor: "#fff8e1",
              borderLeft: "4px solid #ffc107",
              display: "flex",
              alignItems: "flex-start",
              gap: 1,
            }}
          >
            <Iconify
              icon="mdi:alert-circle-outline"
              color="#ffc107"
              style={{ marginTop: 2 }}
            />
            <Typography
              variant="body2"
              sx={{
                fontSize: "0.875rem",
                color: "#6c757d",
                fontStyle: "italic",
              }}
            >
              {scenario.message}
            </Typography>
          </Box>
          {scenario.requireTableSelection && (
            <Box sx={{ mt: 4 }}>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <TableSelectionAutocompleteInput
                  selectedTable={selectedTable}
                  tablesWithStatus={tablesWithStatus}
                  value={newTable}
                  onChange={handleTableChange}
                />
              </FormControl>
            </Box>
          )}
        </Box>
      </AppDialog>
    </>
  );
}

export default OrderTypeChangeConfirmationDialog;
